<template>
  <div class="ma-10">
    <Loading v-if="isLoading" />
    <Popup
      :message="message"
      v-if="isPopup"
      @close="() => (isPopup = false)"
    />
    <div class="top-container-box">
      <h1>Daftar Karir</h1>
      <div>
        <Button
          icon="+"
          outline
          name="Buat Karir"
          style="background-color: #3b54d9; color: #ffffff; width: 210px"
          @click="() => $router.push('/career/new')"
        />
      </div>
    </div>
    <v-row>
      <v-col cols="6">
        <div class="action-head">
          <div class="f-search">
            <div>
              <v-text-field
                v-model="filter.position"
                type="text"
                class="f-input"
                placeholder="Search..."
                clearable
                dense
                flat
                solo
                style="
                  padding-top: 5px;
                  padding-left: 5px;
                  width: 448px;
                  border-radius: 14px;
                "
                @input="() => getCareers()"
              ></v-text-field>
            </div>
            <div class="f-search-ic">
              <img
                src="/img/icons/search.png"
                style="width: 100%"
                alt="Search Ic"
              />
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
    <NewTable
      :headers="headers"
      :rows="careers"
      :currentPage="currentPage"
      :totalPages="total"
      :totalData="totalData"
      :customColumns="customColumns"
      :perPage="perPage"
      :onEdit="editItem"
      :onView="watchItem"
      :onDelete="onDelete"
      :onPageChange="getCareers"
    />
  </div>
</template>

<script>
import Button from "@/components/Button.vue";
import Loading from "@/components/ilustration/Loading.vue";
import Popup from "@/components/others/Popup.vue";
import NewTable from "@/components/Tabel.vue";
// import FilterIcon from "@/components/icons/Filter.vue";
// import FilterModal from "@/components/FilterModal.vue";
import getAuthentification from "@/utils/badrequest.js";

export default {
  name: "Career",
  components: {
    Button,
    Loading,
    Popup,
    NewTable,
    // FilterIcon,
    // FilterModal,
  },
  data() {
    return {
      isLoading: false,
      currentPage: 1,
      total: 0,
      perPage: 10,
      totalData: 0,
      message: "",
      isPopup: false,
      isFilterActive: false,
      showFilterModal: false,
      filter: {
        position: "",
        sort_by: "desc",
      },
      filterModal: [
        {
          title: "Urutkan",
          name: "sort_by",
          items: [
            {
              name: "Terlama",
              value: "asc",
            },
            {
              name: "Terbaru",
              value: "desc",
            },
          ],
        },
      ],
      headers: [
        {
          text: "POSISI",
          field: "position",
          width: 200,
        },
        {
          text: "PERUSAHAAN",
          field: "company",
          width: 200,
        },
        {
          text: "TIPE KONTRAK",
          field: "contract_type",
          width: 150,
        },
        {
          text: "TIPE PEKERJAAN",
          field: "work_type",
          width: 150,
        },
        {
          text: "LEVEL",
          field: "level",
          width: 150,
        },
        {
          text: "STATUS",
          field: "is_active",
          width: 100,
        },
      ],
      careers: [],
      customColumns: [
        {
          field: "is_active",
          render: (row) => {
            return `<span style="color: ${row.is_active ? 'green' : 'red'}">${row.is_active ? 'Aktif' : 'Non Aktif'}</span>`;
          },
        },
      ],
    };
  },
  methods: {
    async getCareers(page) {
      if (!page) page = this.currentPage;
      else this.currentPage = page;

      this.isLoading = true;
      try {
        const response = await this.$crm_http.get(
          `/v1/career?page=${page}&per_page=${this.perPage}&sort_by=${this.filter.sort_by}&position=${this.filter.position || ""}`
        );
        const res = response.data.data.careers || []
        this.careers = res.map((element) => ({
          id: element.id,
          position: element.position,
          company: element.company,
          contract_type: element.contract_type,
          work_type: element.work_type,
          level: element.level,
          is_active: element.is_active,
        }));
        const t = parseInt(response.data.data.total);
        this.total = Math.ceil(t / this.perPage) || 1;
        this.totalData = t;
        if (this.currentPage > this.total) {
          this.currentPage = this.total;
          this.getCareers();
        }
      } catch (err) {
        this.message = err.response?.data?.data || "Failed to load data.";
        this.isPopup = true;
      } finally {
        this.isLoading = false;
      }
    },
    watchItem(id) {
      this.$router.push("/career/watch/" + id);
    },
    editItem(id) {
      this.$router.push("/career/edit/" + id);
    },
    async onDelete(id) {
      this.isLoading = true;
      try {
        await this.$crm_http.delete("/v1/career/" + id);
        this.getCareers();
      } catch (err) {
        this.message = err.response?.data?.data || "Failed to delete data.";
        this.isPopup = true;
      } finally {
        this.isLoading = false;
      }
    },
    clearFilter() {
      this.isFilterActive = false;
      this.filter = {
        position: "",
        sort_by: "desc",
      };
      this.getCareers();
    },
    handleClearButtonClick() {
      this.filter = {
        position: "",
        sort_by: this.filter.sort_by,
      };
      this.updateIsFilterActive();
    },
    updateIsFilterActive() {
      this.isFilterActive = !(
        this.filter.sort_by === "desc" &&
        !this.filter.position
      );
    },
  },
  beforeCreate() {
    getAuthentification();
  },
  mounted() {
    this.getCareers();
  },
};
</script>

<style scoped>
.action-head {
  margin-top: 7px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.f-search {
  border: 1px solid #d3d6e1;
  width: 100%;
  height: 48px;
  gap: 10px;
  display: flex;
  border-radius: 10px;
  background-color: white;
}
.f-search-ic {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25px;
  margin-right: 18px;
}
.f-input {
  width: 86%;
  background: transparent;
  border: none;
}
.f-input:focus {
  background: transparent;
  border: none;
  outline-width: 0;
}
.top-container-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}
.form-input {
  border-radius: 14px !important;
  background-color: transparent !important;
}
.count-data {
  position: relative;
  top: -60px;
  width: 30%;
}
.no-pagination {
  margin-top: 20px;
  margin-left: 5px;
}
</style>